import { lazy } from "react";
import routes from "./routesConfig/index";

const EmployerPage = lazy(() => import("../Employer/EmployerPage"));
const EmployerDetailPage = lazy(() => import("../Employer/employer-details/EmployerDetailPage"));
const DuplicatesEmployerTable = lazy(() => import("../Employer/duplicates/DuplicatesEmployerTable"));
const employerRoutes = [
    { path: routes.employers, component: EmployerPage, permissionKey: "employer_access", moduleKey: "employer" },
    { path: routes.employerDetails, component: EmployerDetailPage, permissionKey: "employer_access", moduleKey: "employer" },
    { path: routes.DuplicatesEmployers, component: DuplicatesEmployerTable, permissionKey: "employer_access", moduleKey: "employer" }

];

export default employerRoutes;